import { useTranslation } from 'react-i18next';
import useMapLayersState from '../../state/useMapLayersState';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';
import { MapBaseLayerNames } from '../../components/Map/constants';

export const useMapBaseLayerKeyboardShortcuts = (): void => {
  const { t } = useTranslation();
  const { setMapBaseLayer } = useMapLayersState();
  useKeyboardShortcuts([
    {
      category: 'baseMap',
      description: t('keyboardShortcuts.mapBaseLayer.street'),
      keys: 'b 1',
      handler: () => setMapBaseLayer(MapBaseLayerNames.STREET),
    },
    {
      category: 'baseMap',
      description: t('keyboardShortcuts.mapBaseLayer.satellite'),
      keys: 'b 2',
      handler: () => setMapBaseLayer(MapBaseLayerNames.SATELLITE),
    },
    {
      category: 'baseMap',
      description: t('keyboardShortcuts.mapBaseLayer.topographic'),
      keys: 'b 3',
      handler: () => setMapBaseLayer(MapBaseLayerNames.TOPOGRAPHIC),
    },
  ]);
};
